/**
 * アシックス商事の商品かどうかを判定する
 * @param url
 * @returns boolean
 */
export const isATRShoes = (url: string | null) => {
  const TARGET_DOMAIN = 'www.asics-trading.co.jp';

  if (!url) return false;

  try {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname === TARGET_DOMAIN;
  } catch (e) {
    return false;
  }
};
